var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useState } from 'react';
import { RoomEvent, ScreenSharePresets, Track } from 'livekit-client';
import { toast } from 'react-toastify';
export function useScreenShare(room) {
    var _this = this;
    var _a = useState(false), isScreenSharing = _a[0], setIsScreenSharing = _a[1];
    useEffect(function () {
        if (!room)
            return;
        var handleTrackUnpublished = function (publication, participant) {
            if (participant.isLocal && publication.source === Track.Source.ScreenShare) {
                setIsScreenSharing(false);
            }
        };
        room.on(RoomEvent.TrackUnpublished, handleTrackUnpublished);
        return function () {
            room.off(RoomEvent.TrackUnpublished, handleTrackUnpublished);
        };
    }, [room]);
    // Отслеживаем остановку screen share через браузер
    useEffect(function () {
        var _a;
        if (!room || !isScreenSharing)
            return;
        var screenShareTrack = (_a = room.localParticipant.getTrackPublication(Track.Source.ScreenShare)) === null || _a === void 0 ? void 0 : _a.track;
        if (!(screenShareTrack === null || screenShareTrack === void 0 ? void 0 : screenShareTrack.mediaStreamTrack))
            return;
        var handleTrackEnded = function () {
            console.log('Screen share track ended by browser');
            setIsScreenSharing(false);
            toast.info('Трансляция экрана остановлена');
        };
        screenShareTrack.mediaStreamTrack.addEventListener('ended', handleTrackEnded);
        return function () {
            var _a;
            (_a = screenShareTrack.mediaStreamTrack) === null || _a === void 0 ? void 0 : _a.removeEventListener('ended', handleTrackEnded);
        };
    }, [room, isScreenSharing]);
    var startScreenShare = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var publication, settings, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!room)
                        return [2 /*return*/];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, room.localParticipant.setScreenShareEnabled(true, {
                            resolution: ScreenSharePresets.h720fps15.resolution,
                            contentHint: 'detail',
                        })];
                case 2:
                    publication = _c.sent();
                    settings = (_b = (_a = publication === null || publication === void 0 ? void 0 : publication.track) === null || _a === void 0 ? void 0 : _a.mediaStreamTrack) === null || _b === void 0 ? void 0 : _b.getSettings();
                    console.debug('Screen share capture settings', {
                        width: settings === null || settings === void 0 ? void 0 : settings.width,
                        height: settings === null || settings === void 0 ? void 0 : settings.height,
                        frameRate: settings === null || settings === void 0 ? void 0 : settings.frameRate,
                    });
                    setIsScreenSharing(true);
                    toast.success('Трансляция экрана начата');
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _c.sent();
                    console.error('Failed to start screen share:', error_1);
                    if (error_1.name === 'NotAllowedError' || error_1.name === 'AbortError') {
                        toast.info('Трансляция экрана отменена');
                    }
                    else {
                        toast.error('Не удалось начать трансляцию экрана');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [room]);
    var stopScreenShare = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!room)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, room.localParticipant.setScreenShareEnabled(false)];
                case 2:
                    _a.sent();
                    setIsScreenSharing(false);
                    toast.success('Трансляция экрана остановлена');
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    console.error('Failed to stop screen share:', error_2);
                    toast.error('Ошибка при остановке трансляции экрана');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [room]);
    var cleanup = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(isScreenSharing && room)) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, room.localParticipant.setScreenShareEnabled(false)];
                case 2:
                    _a.sent();
                    setIsScreenSharing(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _a.sent();
                    console.error('Failed to stop screen share on cleanup:', error_3);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [isScreenSharing, room]);
    return {
        isScreenSharing: isScreenSharing,
        startScreenShare: startScreenShare,
        stopScreenShare: stopScreenShare,
        cleanup: cleanup,
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlU2NyZWVuU2hhcmUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9saWIvaG9va3MvdXNlU2NyZWVuU2hhcmUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLFdBQVcsRUFBRSxTQUFTLEVBQUUsUUFBUSxFQUFFLE1BQU0sT0FBTyxDQUFDO0FBQ3pELE9BQU8sRUFBUSxTQUFTLEVBQUUsa0JBQWtCLEVBQUUsS0FBSyxFQUFFLE1BQU0sZ0JBQWdCLENBQUM7QUFDNUUsT0FBTyxFQUFFLEtBQUssRUFBRSxNQUFNLGdCQUFnQixDQUFDO0FBRXZDLE1BQU0sVUFBVSxjQUFjLENBQUMsSUFBaUI7SUFBaEQsaUJBZ0dDO0lBL0ZPLElBQUEsS0FBd0MsUUFBUSxDQUFDLEtBQUssQ0FBQyxFQUF0RCxlQUFlLFFBQUEsRUFBRSxrQkFBa0IsUUFBbUIsQ0FBQztJQUU5RCxTQUFTLENBQUM7UUFDUixJQUFJLENBQUMsSUFBSTtZQUFFLE9BQU87UUFFbEIsSUFBTSxzQkFBc0IsR0FBRyxVQUFDLFdBQWdCLEVBQUUsV0FBZ0I7WUFDaEUsSUFBSSxXQUFXLENBQUMsT0FBTyxJQUFJLFdBQVcsQ0FBQyxNQUFNLEtBQUssS0FBSyxDQUFDLE1BQU0sQ0FBQyxXQUFXLEVBQUUsQ0FBQztnQkFDM0Usa0JBQWtCLENBQUMsS0FBSyxDQUFDLENBQUM7WUFDNUIsQ0FBQztRQUNILENBQUMsQ0FBQztRQUVGLElBQUksQ0FBQyxFQUFFLENBQUMsU0FBUyxDQUFDLGdCQUFnQixFQUFFLHNCQUFzQixDQUFDLENBQUM7UUFFNUQsT0FBTztZQUNMLElBQUksQ0FBQyxHQUFHLENBQUMsU0FBUyxDQUFDLGdCQUFnQixFQUFFLHNCQUFzQixDQUFDLENBQUM7UUFDL0QsQ0FBQyxDQUFDO0lBQ0osQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQztJQUVYLG1EQUFtRDtJQUNuRCxTQUFTLENBQUM7O1FBQ1IsSUFBSSxDQUFDLElBQUksSUFBSSxDQUFDLGVBQWU7WUFBRSxPQUFPO1FBRXRDLElBQU0sZ0JBQWdCLEdBQUcsTUFBQSxJQUFJLENBQUMsZ0JBQWdCLENBQUMsbUJBQW1CLENBQUMsS0FBSyxDQUFDLE1BQU0sQ0FBQyxXQUFXLENBQUMsMENBQUUsS0FBSyxDQUFDO1FBQ3BHLElBQUksQ0FBQyxDQUFBLGdCQUFnQixhQUFoQixnQkFBZ0IsdUJBQWhCLGdCQUFnQixDQUFFLGdCQUFnQixDQUFBO1lBQUUsT0FBTztRQUVoRCxJQUFNLGdCQUFnQixHQUFHO1lBQ3ZCLE9BQU8sQ0FBQyxHQUFHLENBQUMscUNBQXFDLENBQUMsQ0FBQztZQUNuRCxrQkFBa0IsQ0FBQyxLQUFLLENBQUMsQ0FBQztZQUMxQixLQUFLLENBQUMsSUFBSSxDQUFDLCtCQUErQixDQUFDLENBQUM7UUFDOUMsQ0FBQyxDQUFDO1FBRUYsZ0JBQWdCLENBQUMsZ0JBQWdCLENBQUMsZ0JBQWdCLENBQUMsT0FBTyxFQUFFLGdCQUFnQixDQUFDLENBQUM7UUFFOUUsT0FBTzs7WUFDTCxNQUFBLGdCQUFnQixDQUFDLGdCQUFnQiwwQ0FBRSxtQkFBbUIsQ0FBQyxPQUFPLEVBQUUsZ0JBQWdCLENBQUMsQ0FBQztRQUNwRixDQUFDLENBQUM7SUFDSixDQUFDLEVBQUUsQ0FBQyxJQUFJLEVBQUUsZUFBZSxDQUFDLENBQUMsQ0FBQztJQUU1QixJQUFNLGdCQUFnQixHQUFHLFdBQVcsQ0FBQzs7Ozs7O29CQUNuQyxJQUFJLENBQUMsSUFBSTt3QkFBRSxzQkFBTzs7OztvQkFHSSxxQkFBTSxJQUFJLENBQUMsZ0JBQWdCLENBQUMscUJBQXFCLENBQUMsSUFBSSxFQUFFOzRCQUMxRSxVQUFVLEVBQUUsa0JBQWtCLENBQUMsU0FBUyxDQUFDLFVBQVU7NEJBQ25ELFdBQVcsRUFBRSxRQUFRO3lCQUN0QixDQUFDLEVBQUE7O29CQUhJLFdBQVcsR0FBRyxTQUdsQjtvQkFFSSxRQUFRLEdBQUcsTUFBQSxNQUFBLFdBQVcsYUFBWCxXQUFXLHVCQUFYLFdBQVcsQ0FBRSxLQUFLLDBDQUFFLGdCQUFnQiwwQ0FBRSxXQUFXLEVBQUUsQ0FBQztvQkFDckUsT0FBTyxDQUFDLEtBQUssQ0FBQywrQkFBK0IsRUFBRTt3QkFDN0MsS0FBSyxFQUFFLFFBQVEsYUFBUixRQUFRLHVCQUFSLFFBQVEsQ0FBRSxLQUFLO3dCQUN0QixNQUFNLEVBQUUsUUFBUSxhQUFSLFFBQVEsdUJBQVIsUUFBUSxDQUFFLE1BQU07d0JBQ3hCLFNBQVMsRUFBRSxRQUFRLGFBQVIsUUFBUSx1QkFBUixRQUFRLENBQUUsU0FBUztxQkFDL0IsQ0FBQyxDQUFDO29CQUNILGtCQUFrQixDQUFDLElBQUksQ0FBQyxDQUFDO29CQUN6QixLQUFLLENBQUMsT0FBTyxDQUFDLDBCQUEwQixDQUFDLENBQUM7Ozs7b0JBRTFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsK0JBQStCLEVBQUUsT0FBSyxDQUFDLENBQUM7b0JBQ3RELElBQUksT0FBSyxDQUFDLElBQUksS0FBSyxpQkFBaUIsSUFBSSxPQUFLLENBQUMsSUFBSSxLQUFLLFlBQVksRUFBRSxDQUFDO3dCQUNwRSxLQUFLLENBQUMsSUFBSSxDQUFDLDRCQUE0QixDQUFDLENBQUM7b0JBQzNDLENBQUM7eUJBQU0sQ0FBQzt3QkFDTixLQUFLLENBQUMsS0FBSyxDQUFDLHFDQUFxQyxDQUFDLENBQUM7b0JBQ3JELENBQUM7Ozs7O1NBRUosRUFBRSxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUM7SUFFWCxJQUFNLGVBQWUsR0FBRyxXQUFXLENBQUM7Ozs7O29CQUNsQyxJQUFJLENBQUMsSUFBSTt3QkFBRSxzQkFBTzs7OztvQkFHaEIscUJBQU0sSUFBSSxDQUFDLGdCQUFnQixDQUFDLHFCQUFxQixDQUFDLEtBQUssQ0FBQyxFQUFBOztvQkFBeEQsU0FBd0QsQ0FBQztvQkFDekQsa0JBQWtCLENBQUMsS0FBSyxDQUFDLENBQUM7b0JBQzFCLEtBQUssQ0FBQyxPQUFPLENBQUMsK0JBQStCLENBQUMsQ0FBQzs7OztvQkFFL0MsT0FBTyxDQUFDLEtBQUssQ0FBQyw4QkFBOEIsRUFBRSxPQUFLLENBQUMsQ0FBQztvQkFDckQsS0FBSyxDQUFDLEtBQUssQ0FBQyx3Q0FBd0MsQ0FBQyxDQUFDOzs7OztTQUV6RCxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQztJQUVYLElBQU0sT0FBTyxHQUFHLFdBQVcsQ0FBQzs7Ozs7eUJBQ3RCLENBQUEsZUFBZSxJQUFJLElBQUksQ0FBQSxFQUF2Qix3QkFBdUI7Ozs7b0JBRXZCLHFCQUFNLElBQUksQ0FBQyxnQkFBZ0IsQ0FBQyxxQkFBcUIsQ0FBQyxLQUFLLENBQUMsRUFBQTs7b0JBQXhELFNBQXdELENBQUM7b0JBQ3pELGtCQUFrQixDQUFDLEtBQUssQ0FBQyxDQUFDOzs7O29CQUUxQixPQUFPLENBQUMsS0FBSyxDQUFDLHlDQUF5QyxFQUFFLE9BQUssQ0FBQyxDQUFDOzs7OztTQUdyRSxFQUFFLENBQUMsZUFBZSxFQUFFLElBQUksQ0FBQyxDQUFDLENBQUM7SUFFNUIsT0FBTztRQUNMLGVBQWUsaUJBQUE7UUFDZixnQkFBZ0Isa0JBQUE7UUFDaEIsZUFBZSxpQkFBQTtRQUNmLE9BQU8sU0FBQTtLQUNSLENBQUM7QUFDSixDQUFDIn0=